import { dispatchTwiceGetImpactVenueCo2 } from '@/domain/impact-calculate-venue/actions/utils/dispatch-twice-get-impact-venue-co2';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { reloadMonthDeclarations } from '@/domain/project-venue-month-declaration/actions/reload-month-declaration.action.ts';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getVenueDates } from './get-venue-dates.action';

export const deleteVenueDate = createAppAsyncThunk(
  'projectVenueDates/deleteVenueDate',
  async (
    id: number,
    {
      extra: { projectVenueDatesGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<void> => {
    try {
      await projectVenueDatesGateway.delete(id);
      await dispatch(getVenueDates());
      const currentProject = selectCurrentProjectVenue(getState());
      if (currentProject) {
        dispatchTwiceGetImpactVenueCo2(dispatch, currentProject.id);
      }
      await dispatch(reloadMonthDeclarations());
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('DeleteVenueDate.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('DeleteVenueDate.Message.error'));
}
